/**
 * ColumnContainer Component
 *
 * Holds all 6 clue cells for a single column.
 * Size: 196×504px
 * Contains 6 buttons positioned at: 0, 78, 180, 258, 360, 438
 */

import React from 'react';
import ClueCell from './ClueCell';
import styles from './ColumnContainer.module.css';

interface ColumnContainerProps {
  columnIndex: number;
  celebrationGoldCol?: number;
  bannerDialogVisible?: boolean;
}

// Row Y positions within column container (spec: 0, 78, 180, 258, 360, 438)
const ROW_Y_POSITIONS = [0, 78, 180, 258, 360, 438];

const ColumnContainer: React.FC<ColumnContainerProps> = ({ columnIndex, celebrationGoldCol = -1, bannerDialogVisible = false }) => {
  return (
    <div className={styles.columnContainer}>
      {[0, 1, 2, 3, 4, 5].map(rowIndex => (
        <div
          key={rowIndex}
          className={styles.cellWrapper}
          style={{
            top: `${ROW_Y_POSITIONS[rowIndex]}px`,
          }}
        >
          <ClueCell columnIndex={columnIndex} rowIndex={rowIndex} celebrationGoldCol={celebrationGoldCol} bannerDialogVisible={bannerDialogVisible} />
        </div>
      ))}
    </div>
  );
};

export default React.memo(ColumnContainer);
